<ng-template
    #optionMarketPickTemplate
    let-pick="pick"
    let-hideLineSwitcher="hideLineSwitcher"
    let-hideActionButton="hideActionButton"
    let-showEachWay="showEachWay"
    let-messages="messages"
    let-betslipType="betslipType"
    let-marketLogoTooltipAppendTo="marketLogoTooltipAppendTo"
    let-marketLogoTooltipBoundaries="marketLogoTooltipBoundaries"
    let-marketLogoTooltipPlacement="marketLogoTooltipPlacement"
    let-marketLogoTrackingLocation="marketLogoTrackingLocation"
    let-hideEventName="hideEventName"
    let-marketLogoLinearBetslip="marketLogoLinearBetslip"
    let-wrapMarketLogoTitle="wrapMarketLogoTitle">
    <div class="betslip-digital-pick__line-0">
        <span class="betslip-digital-pick__line-0-container">
            <span class="betslip-info_pick-name" *ngIf="isHorseOptionMarketAnycastPick(pick)">
                <span *ngFor="let p of getSortedPickOptions(pick); index as i; last as isLast">
                    <span class="pick_name__participant_pos">{{ $any(sitecore.horseRacing.common)[i + 1] }}</span>
                    <span>
                        <strong>{{ p.name.name }}</strong>
                        <ng-container *ngIf="!isLast">, </ng-container>
                    </span>
                </span>
            </span>
            <span *ngIf="!isHorseOptionMarketAnycastPick(pick)" [msAutomation]="'betslip-digital-pick__option-name'">{{ pick.optionName.name }}</span>
            <bs-line-switcher-button *ngIf="!hideActionButton && !hideLineSwitcher" [pick]="pick" />
        </span>
    </div>
    <div class="betslip-digital-pick__line-1" [msAutomation]="'betslip-digital-pick__market-name'">
        {{ optionMarketName(pick, showEachWay) }}
    </div>
    <div class="betslip-digital-pick__line-2" *ngIf="!hideEventName">
        <ng-container *msShowInEpcot="{ showInEpcot: true }">
            <span class="betslip-digital-pick__virtual-badge icon" *ngIf="pick.isVirtual" [class]="'sports-' + pick.sportId"></span>
        </ng-container>
        <ng-container *msShowInEpcot="{ showInEpcot: false }">
            <span class="betslip-digital-pick__virtual-badge theme-virtualsport" *ngIf="pick.isVirtual"></span>
        </ng-container>
        <span class="betslip-digital-pick__live-badge" *ngIf="pick.isLive && !isEpcotEnabled">{{ messages.common.Live }}</span>
        <span *ngIf="isHorseRaceOptionPick(pick)">{{ pick.fixture.eventDate | date: 'HH:mm' }}</span>
        <span [msAutomation]="'betslip-digital-pick__event-name'">{{ pick.eventName.name }}</span>
        <div class="badge-left" *ngIf="pick.isLive && isEpcotEnabled">
            <span class="betslip-digital-pick__live-badge">{{ messages.common.Live }}</span>
        </div>
    </div>
    <div class="betslip-digital-pick__line-3" *ngIf="!hideActionButton && (!!pick.isStartingPriceAvailable?.() || pick.isEachWay)">
        <bs-starting-price-button
            *ngIf="isHorseRaceOptionPick(pick) && !!pick.isStartingPriceAvailable?.()"
            [pick]="pick"
            [betslipType]="betslipType" />
        <bs-eachway-price-button *ngIf="pick.isEachWay" [betslipType]="betslipType" [pick]="pick" />
    </div>
    <ms-marketsubtype-logo
        class="betslip-digital-pick__line-last"
        *ngIf="marketSubTypeLogoTitle$(pick, betslipType) | async"
        [eventId]="pick.id.fixtureId"
        [marketType]="pick.market.marketType"
        [marketSubType]="pick.market.marketSubType"
        [templateId]="pick.market.templateId"
        [matchName]="pick.eventName.name"
        [sportId]="pick.sportId"
        [trackingLocation]="marketLogoTrackingLocation"
        [tooltipAppendTo]="marketLogoTooltipAppendTo"
        [tooltipBoundaries]="marketLogoTooltipBoundaries"
        [tooltipPlacement]="marketLogoTooltipPlacement"
        [wrapMarketLogoTitle]="wrapMarketLogoTitle" />
    <div class="marketsubtype-signposting-text" *ngIf="marketSubTypeSignpostingText$(pick, betslipType) | async as signPostingText">
        {{ signPostingText }}
    </div>
</ng-template>

<ng-template
    #participantPickTemplate
    let-pick="pick"
    let-hideLineSwitcher="hideLineSwitcher"
    let-hideActionButton="hideActionButton"
    let-messages="messages"
    let-showEachWay="showEachWay"
    let-betslipType="betslipType">
    <div class="betslip-digital-pick__line-0">
        <span [msAutomation]="'betslip-digital-pick__option-name'">{{ pick.optionName.name }}</span>
    </div>
    <div class="betslip-digital-pick__line-1" [msAutomation]="'betslip-digital-pick__market-name'">
        {{ showEachWay && isHorseEachWayPick(pick) ? messages.common.EachWay : pick.marketName.name }}
    </div>
    <div class="betslip-digital-pick__line-2">
        <span *ngIf="pick.fixture.fixtureType === 'DayOfRace'">{{ pick.fixture.eventDate | date: 'HH:mm' }}</span>
        <span [msAutomation]="'betslip-digital-pick__event-name'">{{ pick.eventName.name }}</span>
    </div>
    <div class="betslip-digital-pick__line-3" *ngIf="!hideActionButton && (!!pick.isStartingPriceAvailable?.() || pick.isEachWay)">
        <bs-starting-price-button *ngIf="!!pick.isStartingPriceAvailable?.()" [pick]="pick" [betslipType]="betslipType" />
        <bs-eachway-price-button *ngIf="pick.isEachWay" [betslipType]="betslipType" [pick]="pick" />
    </div>
</ng-template>

<ng-template #betBuilderPickTemplate let-pick="pick" let-messages="messages">
    <bs-betslip-betbuilder-pick class="betslip-digital-pick__line-0" [pick]="pick" />
    <bs-betslip-betbuilder-edit-pick-button *ngIf="showBABEditButton(pick)" [ngClass]="betBuilderEditPickButtonClass(pick)" [pick]="pick" />
</ng-template>

<ng-template #groupedPickTemplate let-pick="pick" let-messages="messages">
    <bs-betslip-group-pick class="betslip-digital-pick__line-0" [pick]="pick" />
    <bs-betslip-betbuilder-edit-pick-button class="betslip-digital-pick__line-2" [pick]="pick" />
</ng-template>

<ng-template #unknownPickTemplate>
    <div class="betslip-digital-pick__line-0">
        <div class="betslip-pick-loading">Loading..</div>
    </div>
    <div class="betslip-digital-pick__line-1">
        <div class="betslip-pick-loading">Loading..</div>
    </div>
    <div class="betslip-digital-pick__line-2">
        <div class="betslip-pick-loading">Loading..</div>
    </div>
</ng-template>
